<template>
    <section class="news">
        <div class="news_menu">
            <h2><span v-text="title"></span></h2>
            <div class="menu_track">
                <div class="menu" :style="menuCss" ref="menu">
                    <button class="menu_button" v-for="category, index in menuCategories"
                        :class="{ active: selectedCategoryIndex === index }" @click="selectedCategoryIndex = index"
                        :key="category.id">
                        <span v-text="category.name"></span>
                    </button>
                </div>
            </div>
        </div>

        <div class="news_track">

            <div class="news_item" v-for="post in postsToDisplay" :key="post.id" :to="post.link">
                <router-link class="news_highlightImage" :to="post.link">
                    <ImageLoader :src="post.images.medium" />
                </router-link>

                <div class="news_meta">
                    <CategoryButton :categories="post.categories" />
                    <router-link :to="post.link" v-text="postDate(post)" class="newsMeta_date">
                    </router-link>
                </div>

                <router-link class="newsMeta_description" :to="post.link">
                    <h3 v-html="post.title.rendered"></h3>
                    <div v-html="post.excerpt.rendered" class="text"></div>
                </router-link>

                <div class="news_actions">
                    <BetButton :to="post.link" text="Ver mais" />
                </div>

            </div>

            <div class="news_navigation" v-show="posts.length">
                <img src="../assets/images/chevron-right.svg" alt="" class="left" @click.prevent="goToPrev">
                <img src="../assets/images/chevron-right.svg" alt="" class="right" @click.prevent="goToNext">
            </div>

            <router-link class="news_item-placeholder news_item" v-for="i in 3" :key="i" to="#"
                v-show="posts.length == 0">
                <div class="news_highlightImage"></div>
                <div class="news_meta">
                    <a href="#" class="newsMeta_category">
                        <span>
                            <CategoryName :id="''" />
                        </span>
                    </a>
                    <a href="i" class="newsMeta_date">
                    </a>
                </div>
                <div class="newsMeta_description">
                    <h3></h3>
                    <div>
                        <p></p>
                        <p></p>
                        <p></p>
                    </div>
                </div>
                <div class="news_actions">
                    <span class="button">...</span>
                </div>
            </router-link>

        </div>

        <SliderButtons :currentSlide="postsSlideIndex" :nrOfSlides="posts.length" v-if="posts.length"
            class="news_buttons" @update:currentSlide="postsSlideIndex = $event" />

    </section>

</template>

<script>
import SliderButtons from "@/components/Slider/Buttons.vue"
import ImageLoader from "@/components/ImageLoader.vue"
import BetButton from "./BetButton.vue"
import CategoryButton from "@/components/Categories/Button.vue"
import CategoryName from "@/components/Categories/Name.vue"
import moment from "moment"

export default {
    name: 'PostsBlock',
    components: {
        BetButton,
        CategoryButton,
        CategoryName,
        ImageLoader,
        SliderButtons,
    },
    props: {
        children: {
            default: false,
        },
        posts: {
            required: true,
        },
        menuCategories: {
            default: [],
        },
        title: {
            default: 'Notícias',
        },
        startCategories: {
            default: null,
        },
    },
    data() {
        return {
            selectedCategoryIndex: 0,
            postsSlideIndex: 0,
            buttonWidth: "100%",
            startCategoryIsSet: false,
        }
    },
    methods: {
        calcButtonWidth() {
            if (this.$refs.menu == null) {
                return
            }
            let btns = this.$refs.menu.querySelectorAll(".menu_button")
            this.buttonWidth = 0
            for (let btn of btns) {
                if (btn.clientWidth > this.buttonWidth) {
                    this.buttonWidth = btn.clientWidth
                }
            }
            if (this.buttonWidth == 0) {
                this.buttonWidth = "100%"
                return
            }
            this.buttonWidth = `${this.buttonWidth}px`
        },
        goToNext() {
            let slides = parseInt(getComputedStyle(this.$el).getPropertyValue('--news-items-per-slide'))
            this.postsSlideIndex = this.postsSlideIndex + slides
            if (this.postsSlideIndex >= this.posts.length) {
                this.postsSlideIndex = 0
            }
        },
        goToPrev() {
            let slides = parseInt(getComputedStyle(this.$el).getPropertyValue('--news-items-per-slide'))
            if (this.postsSlideIndex == 0) {
                let offset = slides - (this.posts.length % slides)
                if (offset == slides) offset = 0
                this.postsSlideIndex = this.posts.length - slides + offset
            } else {
                this.postsSlideIndex = (this.postsSlideIndex - slides)
            }
        },
        postDate(post) {
            let date = moment(post.date)
            return date.format("DD MMM YYYY")
        },
        setStartCategory() {
            if (this.startCategoryIsSet) {
                return
            }
            const ids = this.menuCategories.map(({ id }) => id)
            if (ids.length == 0) {
                return
            }
            this.selectedCategoryIndex = 0
            //let found = false
            for (let id of ids) {
                if (this.startCategories.includes(id)) {
                    //found = true
                    break
                }
                this.selectedCategoryIndex += 1
            }
            this.selectedCategoryIndex = this.selectedCategoryIndex % ids.length
            //this.startCategoryIsSet = found
        }
    },
    computed: {
        postsCategory() {
            if (this.menuCategories.length) {
                return this.menuCategories[this.selectedCategoryIndex]
            }
            if (this.category == null) {
                return null
            }
            return this.$store.getters["categories/slug"](this.category)
        },
        menuCss() {
            return {
                '--selected-category': this.selectedCategoryIndex,
                '--button-width': this.buttonWidth,
            }
        },
        nrOfSlides() {
            return Math.ceil(this.posts.length / 3)
        },
        postsToDisplay() {
            let position = this.postsSlideIndex
            return this.posts.slice(position, position + 3)
        },
    },
    watch: {
        menuCategories: {
            immediate: true,
            handler(n, o) {
                console.log("CAT", n)
                if ((o != null && n != null) && o.length == n.length) {
                    let change = false
                    let nIds = n.map(({ id }) => id)
                    for (let cat of o) {
                        if (!nIds.includes(cat.id)) {
                            change = true
                            break
                        }
                    }
                    if (!change) {
                        return
                    }
                }
                this.calcButtonWidth()
                this.setStartCategory()
            }
        },
        postsCategory() {
            this.postsSlideIndex = 0
            if (this.postsCategory == null) {
                return
            }
            this.$store.dispatch("posts/getCategory", this.postsCategory)
        },
        selectedCategoryIndex() {
            this.$emit('category', this.selectedCategoryIndex);
        },
        startCategories: {
            immediate: true,
            handler(n, o) {
                console.log(n)
                if ((o != null && n != null) && o.length == n.length) {
                    let change = false
                    for (let cat of o) {
                        if (!n.includes(cat)) {
                            change = true
                            break
                        }
                    }
                    if (!change) {
                        return
                    }
                }
                this.setStartCategory()
            },
        },
    },
    mounted() {
        if (this.category == null) {
            this.$store.dispatch("posts/getAll")
        } else {
            this.$store.dispatch("categories/getOne", this.category)
        }

        if (this.categories != null) {
            this.$store.dispatch("categories/getOne", this.categories.join(','))
        }

        this.calcButtonWidth()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/queries";
@import "@/assets/scss/colors";
@import "@/assets/scss/fonts";

@keyframes fade {
    from {
        opacity: 0
    }

    ;

    to {
        opacity: 1
    }

    ;
}

.news {
    --news-padding: 1rem 0 2rem;
    --news-menu-margin: 0 0 2rem var(--side-padding);
    --menu-height: 5rem;
    --news-items-per-slide: 1;
    --news-items-gap: 1rem;
    --news-items-title-size: 1rem;
    --news-track-padding: 0 var(--side-padding);
    --news-menu-border: 0 0 0 .5rem;
    --news-meta-date-size: 0.5rem;
    --news-meta-gap: 1rem;
    --news-excerpt-size: 0.75rem;
    --news-width: 100%;

    @include media(sm) {
        --news-padding: 4rem 0;
        --news-menu-margin: 4rem 0 2rem;
        --news-items-gap: 3rem;
        --news-items-per-slide: 2;
        --news-items-title-size: 1.25rem;
        --news-track-padding: 0 calc(var(--content-width) * .065 * .5);
        --news-meta-date-size: 0.70613rem;
        --news-meta-gap: 2rem;
        --news-excerpt-size: 0.875rem;
        --news-width: var(--content-width);
    }

    @include media(md) {
        --news-items-title-size: 1.5rem;
    }

    @include media(lg) {
        --news-items-title-size: 1.75rem;
        --news-items-per-slide: 3;
    }

    margin: auto;

    width: var(--news-width);
    padding: var(--news-padding);

    &_actions {
        grid-area: actions;

        .button {
            padding: 0.59088rem 1.18175rem;
            font-size: 0.51206rem;
            font-style: normal;
            font-weight: 900;
        }
    }

    &_buttons {
        justify-content: center;

        :deep(.slider-control) {
            @include media(sm, $max-break: lg) {
                &:nth-child(even) {
                    display: none;
                }
            }

            @include media(lg) {

                &:nth-child(3n-1),
                &:nth-child(3n) {
                    display: none;
                }
            }
        }

    }

    &_menu {
        margin: var(--news-menu-margin);
        border: solid $color-betano;
        border-width: var(--news-menu-border);
    }

    &_highlightImage {
        grid-area: highlight;
        position: relative;
        min-width: 0;
        width: 100%;
        height: 0;
        padding: calc(100% * 9 / 16) 0 0 0;
    }

    &_navigation {
        grid-area: highlight;
        z-index: 10;
        position: absolute;
        pointer-events: none;
        top: 0;
        left: var(--side-padding);
        right: var(--side-padding);
        margin: auto 0;
        display: flex;
        justify-content: space-between;
        height: calc(var(--content-width) * .567);

        @include media(sm) {
            bottom: 0;
            left: 0;
            right: 0;
            height: calc(var(--content-width) * .167);
        }

        img {
            margin: auto 0;
            width: calc(var(--content-width) * .065 * .9 * 3);
            height: 100%;
            pointer-events: all;
            padding: 0 var(--side-padding);

            @include media(sm) {
                height: calc(var(--content-width) * .065 * .4);
                width: calc(var(--content-width) * .065 * .4);
                padding: 0;
            }

            &.left {
                transform: rotate(180deg);
            }

        }
    }

    &_meta {
        grid-area: meta;
        display: flex;
    }
}

.news {
    &_track {
        display: flex;
        gap: var(--news-items-gap);
        padding: var(--news-track-padding);
        overflow: hidden;
        position: relative;
    }

    &_item {
        --news-items-width: calc((100% / var(--news-items-per-slide)) - ((var(--news-items-per-slide) - 1) * var(--news-items-gap)) / var(--news-items-per-slide));

        flex-grow: 1;
        flex-basis: 0;
        display: grid;
        gap: var(--news-meta-gap);
        grid-template-rows: repeat(2, min-content) 1fr min-content;
        grid-template-areas:
            "highlight"
            "meta"
            "description"
            "actions"
        ;
        flex-direction: column;
        width: var(--news-items-width);
        max-width: var(--news-items-width);
        min-width: var(--news-items-width);
        text-decoration: none;

        animation-name: fade;
        animation-fill-mode: forwards;
        animation-timing-function: ease-out;
        animation-duration: .4s;

        @include media(sm, true) {
            &:not(:first-of-type) {
                display: none;
            }
        }

        &-placeholder {

            @include media(sm, true) {
                &:not(:first-of-type) {
                    display: none;
                }
            }

            .news_highlightImage {
                background-color: $color-betano;
                opacity: .75;

                img {
                    display: none;
                }
            }

            .newsMeta_description {

                h3 {
                    background-color: $color-betano;
                    border-radius: 1em;
                    height: 1em;
                }

                p {
                    background-color: #6E85A0;
                    height: 1rem;
                    border-radius: 1rem;
                }

            }
        }

        h3 {
            color: $color-betano;
            font-family: $ff-headings;
            font-size: var(--news-items-title-size);
            font-weight: 700;
            line-height: normal;
            text-transform: uppercase;
            margin-bottom: var(--news-meta-gap);
        }

        p {
            --max-lines: 3;
            --lh: #{0.875rem * 2};
            color: #6E85A0;
            font-family: $ff-regular;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: var(--lh);
            position: relative;
            max-height: calc(var(--lh) * var(--max-lines));
            overflow: hidden;
        }
    }
}


.newsMeta {

    &_date {
        color: $color-betano;
        text-decoration: none;
        font-size: var(--news-meta-date-size);
        margin: auto 0 auto 1em;
    }

    &_description {
        grid-area: description;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        text-decoration: none;

        display: flex;
        height: 100%;

        .text {
            margin: auto 0 0 0;
        }

        :deep(p) {
            margin-top: auto;
            font-family: $ff-regular;
            font-size: var(--news-excerpt-size);
            font-style: normal;
            font-weight: 400;
            line-height: 1.8;
        }
    }
}

h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: $color-betano;
    text-transform: uppercase;
    font-weight: bold;
    background-color: #1E1E37;
    padding: 0 1rem;
    height: calc(var(--menu-height) / 2);
    display: flex;
    align-items: center;
    position: relative;
    z-index: 4;
    margin: 0;
    // Typography
    color: $color-betano;
    font-family: $ff-headings;
    font-size: 1.321rem;
    font-weight: 900;
    line-height: normal;
    text-transform: uppercase;

    span {
        display: inline-block;
        transform: translateY(.1em);
    }
}

.menu_track {
    width: 100%;
    overflow: auto;
}

.menu {
    --nr-of-items: 6;
    --selected-category: 0;
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: repeat(var(--nr-of-items), 1fr);

    @include media(sm, true) {
        width: fit-content;
    }

    @include media(sm) {
        display: flex;
    }

    &::after {
        content: '';
        width: calc((100% / var(--nr-of-items)) + 1px);
        height: 100%;
        background: $color-betano;
        display: block;
        position: absolute;
        top: 0;
        z-index: 0;
        transition: left .2s ease-out;
        left: calc((100% / var(--nr-of-items)) * var(--selected-category) - 1px);
    }

    &_button {
        text-transform: uppercase;
        background: rgba(255, 102, 0, 0.10);
        color: $color-betano;
        border: none;
        flex-grow: 1;
        flex-basis: 0;
        width: var(--button-width);
        height: calc(var(--menu-height) / 2);
        position: relative;
        padding: 0 1rem;
        z-index: 1;
        // Typography
        text-align: center;
        font-family: $ff-headings;
        font-size: 0.77638rem;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        // Effects
        cursor: pointer;
        transition: .2s ease-out;
        transition-property: background, color;

        &:hover {
            background: rgba(255, 102, 0, 0.20);
        }

        &.active {
            // background: $color-betano;
            color: #fff;
        }

        &:not(:last-child) {

            &::after {
                --border-height: calc((var(--menu-height) / 2) * .8);
                content: '';
                width: 1px;
                height: var(--border-height);
                background: $color-betano;
                display: block;
                position: absolute;
                right: 0;
                bottom: calc(((var(--menu-height) / 2) - var(--border-height)) / 2);
            }
        }

        span {
            display: inline-block;
            transform: translateY(.1em);
        }
    }
}
</style>
